// src/i18n/en/reconciliation.ts
// English counterpart of `i18n/es/reconciliation.ts` — see there for context.
export const reconciliation = {
  name: 'Reconciliation |||| Reconciliation',
  subtitle: 'Payments accepted, declined, confirmed by the kiosk and unconfirmed, for the finance team',
  provenance: "Declared by the self-service point; not checked against the hotel's system.",

  help: {
    title: 'Reconciliation',
    description:
      "The hotel's payments: accepted, declined, confirmed by the kiosk and unconfirmed, orphaned amounts, refunds and cash. «Payments accepted in self-service» counts only the kiosk, the phone and the online pre-check-in; Air Lobby, run by staff, is left out. «Confirmed by the kiosk» is what the self-service point declares at the end of the journey; it is not yet checked against the hotel's system, which is why the reconciliation rate shows as not available.",
    features: {
      list: 'Every metric carries its coverage/freshness stamp, or the exact remedy when the data is not available.',
    },
    tips: {
      property: 'Switch property at the top left; the default period is the last 30 days.',
    },
  },
};

export default reconciliation;
